import { CaptainIcon, ViceCaptainIcon } from "@roman/shared/components/Icons";
import { cn } from "@roman/shared/utils";

interface PlayerImageProps {
  isCaptain?: boolean;
  isViceCaptain?: boolean;
  url: string | null;
  name: string;
  className?: string;
  badgeClassName?: string;
  imageClassName?: string;
}

export const PlayerImage = ({
  isCaptain,
  isViceCaptain,
  url,
  name,
  className,
  badgeClassName,
  imageClassName,
}: PlayerImageProps) => {
  return (
    <div className={cn("relative w-[40px]", className)}>
      {isCaptain || isViceCaptain ? (
        <div
          className={cn(
            "rounded-full py-[3px] px-[5px] -top-[2px] -left-[5px] absolute border-[2px] border-white ",
            isCaptain ? "bg-primary" : "bg-secondary",
          )}
        >
          {isCaptain ? (
            <CaptainIcon className={cn("w-[25px] h-[14px]", badgeClassName)} />
          ) : (
            <ViceCaptainIcon className={cn("w-[25px] h-[14px]", badgeClassName)} />
          )}
        </div>
      ) : null}
      <img
        src={url || "/assets/player-shirt.png"}
        alt={name}
        className={cn("object-contain rounded-md w-full h-full", imageClassName)}
        draggable={false}
      />
    </div>
  );
};
